import useAccount from "@/hooks/useAccount";
import { useCallback, useEffect, useState } from "react";
import { getCountry } from "@/services/ip";
import { useRouter } from "next/router";

export default function useInvestInfo() {
  const [totalInvest, setTotalInvest] = useState(0);
  const [locale, setLocale] = useState("en");

  const { address } = useAccount();
  const router = useRouter();

  // const update = useCallback(() => {
  //   if (address) {
  //     fetch("https://api-dev.karatdao.com/test_backend/zado/action", {
  //       method: "POST",
  //       headers: {
  //         "content-type": "application/json",
  //       },
  //       body: JSON.stringify({
  //         method: "ido/status",
  //         params: {
  //           userAddress: address,
  //         },
  //       }),
  //     })
  //       .then((resp) => {
  //         return resp.json();
  //       })
  //       .then((result) => {
  //         if (result?.result?.totalAmount) {
  //           setTotalInvest(result.result.totalAmount);
  //         }
  //       });
  //   }
  // }, [address]);

  // useEffect(() => {
  //   update();
  // }, [address]);

  return {
    totalInvest,
    // update,
    locale,
  };
}
